export default [
  {
    path: "/reconciliation/bank-statements",
    name: "BankStatements-View",
    component: () => import("@/views/reports/reconciliation/index.vue"),
    meta: {
      resource: "Reconciliation",
      action: "View",
    },
  },
  {
    path: "/reconciliation/unmatched",
    name: "Reconciliations-unMatchedList",
    component: () => import("@/views/reports/reconciliation/unMatchedList.vue"),
    meta: {
      resource: "Reconciliation",
      action: "ViewUnMatched",
    },
  },
  {
    path: "/reconciliation/unmatchedsummaryreport",
    name: "Reconciliations-UnmatchedSummaryReport",
    component: () =>
      import("@/views/reports/reconciliation/unmatchedSummaryReport.vue"),
    meta: {
      resource: "Reconciliation",
      action: "ViewUnmatchedSummaryReport",
    },
  },
  {
    path: "/reconciliation/resolvedDiscrepancyTxn",
    name: "Reconciliations-ResolvedDiscrepancyTxn",
    component: () =>
      import("@/views/reports/reconciliation/resolvedDiscrepancyTxn.vue"),
    meta: {
      resource: "Reconciliation",
      action: "ViewResolvedDiscrepancyTxn",
    },
  },
  {
    path: "/reconciliation/matched",
    name: "Reconciliations-matchedList",
    component: () => import("@/views/reports/reconciliation/matched.vue"),
    meta: {
      resource: "Reconciliation",
      action: "ViewMatched",
    },
  },

  // {
  //   path: "/reconciliation/Index",
  //   name: "Reconciliations-list",
  //   component: () => import("@/views/reconciliation/Index.vue"),
  //   meta: {
  //     resource: "Reconciliation",
  //     action: "View",
  //   },
  // },
  // {
  //   path: "/reconciliation/unmatched",
  //   name: "Reconciliations-unMatchedList",
  //   component: () => import("@/views/reconciliation/unMatchedList.vue"),
  //   meta: {
  //     resource: "Reconciliation",
  //     action: "ViewUnMatched",
  //   },
  // },
  // {
  //   path: "/reconciliation/matched",
  //   name: "Reconciliations-matchedList",
  //   component: () => import("@/views/reconciliation/matched.vue"),
  //   meta: {
  //     resource: "Reconciliation",
  //     action: "ViewMatched",
  //   },
  // },
];
